import * as React from 'react';
import { ReactNode } from 'react';
import { Checkbox, CheckboxProps } from 'primereact/checkbox';
import Label from '../Label';
import { IntlShape, useIntl } from 'react-intl';
import { getHelp } from '../../../util/intl.utils';

interface Props extends CheckboxProps {
  title?: string;
  required?: boolean;
  invalid?: boolean;
  disabled?: boolean;
}

export const TitledCheckbox: React.FC<Props> = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <div className={'flex align-items-center w-full'}>
      <h4 className={'font-bold flex-grow-1 overflow-hidden'}>
        <Label
          htmlFor={props.inputId}
          label={intl.formatMessage({id: `${props.title}.label`})}
          help={getHelp(intl, `${props.title}.help`)}
          required={props.required}
          validation={{valid: !props.invalid}}
          disabled={props.disabled}
        />
      </h4>
      <Checkbox
        {...props}/>
    </div>
  );
};
